module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADEAAAAkCAMAAAAXWSIGAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAADBQTFRFy9vT2eri1eTd8fHxydLN6PLt29zc8/j1/P39zuDY1NjWytfQ6Ojp0dHR////3u7p21n2pgAAAMJJREFUeNrM1EsSxCAIBFBQY2IUuP9to5NPuZlKU7OZXvtKEZQWnmLfsugTMii8esVEUGH8gwj/JFaveAgubuIQVym04+KcFZfgbYgWPGQdopi5SqFWzUcoSvCRLsgpVKpXtOQSRrq5BGdS9VRe0hAMrg6FqsgQWA+5rx75iITsUk4gcQgp8B571C7AHnLKufXh7WIT7H7D9WoVPdb9mwyhWCHLJDIiSptES/U9SSahgmR3iziLDICss4jtPfe/ewgwAO/8X8lYFPPMAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/components/SP/assets/IA.png
// module id = BVYb
// module chunks = 1